<!-- 申请Demo/样品 表单 -->
<template>
    <div class="apply-form-container">
        <van-popup v-model="applyForm" :safe-area-inset-bottom="true" :close-on-click-overlay="false">
            <div class="form-container">
                <div class="form-content">
                    <div class="btn-switch">
                        <div>{{form_title}}</div>
                    </div>
                    <transition name="van-fade">
                        <div v-show="showForm">
                            <div class="form-list">
                                <div class="formItem" v-for="(item) in formDataList" :key="item.field_id">
                                    <div class="item itemInput" v-if="item.type === 3">
                                        <label class="hint-title" v-if="item.field != 'code'"><span class="sign" v-if="item.required === 1">*</span>{{item.title}}：</label>
                                        <div class="content" v-if="item.field != 'code'">
                                            <div class="right-input" >
                                                <input v-if="item.field != 'industry' && item.field != 'city'" type="text" :placeholder="item.placeholder" v-model="applyFormData[item.field]" @blur="blurChange" @input="contrastPhone">
                                                <input readonly="readonly" v-if="item.field == 'industry'" type="text" placeholder="请选择" v-model="industryName" @click="blurIndustry">
                                                <input readonly="readonly" v-if="item.field == 'city'" type="text" placeholder="请选择" v-model="applyFormData[item.field]" @click="blurCity">
                                            </div>
                                        </div>
                                        <!-- 验证码的判断 -->
                                        <label class="hint-title" v-if="item.field == 'code'"><span class="sign" v-if="item.required === 1">*</span>{{item.title}}：</label>
                                        <div class="content" v-if="item.field == 'code'">
                                            <div style="width:auto" class="right-input code_moblie" v-if="item.field == 'code'">
                                                <input maxlength="6" style="flex:1"  type="text" :placeholder="item.placeholder" v-model="applyFormData[item.field]" @blur="blurChange">
                                                <button @click="getCode" :disabled='getCodeState'  style="color:#000;font-size:12px;">{{ getCodeText }}</button>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="item itemRadio" v-if="item.type === 1">
                                        <label class="hint-title"><span class="sign" v-if="item.required === 1">*</span>{{item.title}}：（单选）</label>
                                        <!-- <label v-for="(valueItem, valueIndex) in item.value" :key="valueIndex" style="display: flex; align-items: center; flex-wrap: wrap">
                                            <input v-model="formItem[item.field]" :name="valueItem.value" type="radio" :value="valueItem.value" />
                                            {{valueItem.value}}
                                        </label> -->
                                        <div class="radio-container">
                                            <van-radio-group v-model="applyFormData[item.field]" direction="horizontal" :checked-color="checkedColor" icon-size="16px">
                                                <div v-for="(valueItem, valueIndex) in item.value" :key="valueIndex" >
                                                    <van-radio :name="valueItem.value">
                                                        {{valueItem.value}}
                                                    </van-radio>
                                                </div>
                                            </van-radio-group>
                                        </div>
                                    </div>
                                    <div class="item itemCheck " v-if="item.type === 2">
                                        <label class="hint-title"><span class="sign" v-if="item.required === 1">*</span>{{item.title}}：（多选）</label>
                                        <van-checkbox-group v-model="applyFormData[item.field]" direction="horizontal">
                                            <div class="checkbox-container">
                                                <div class="checkbox-option" v-for="(valueItem, valueIndex) in item.value" :key="valueIndex">
                                                    <van-checkbox :name="valueItem.value" :checked-color="checkedColor" shape="square" icon-size="16px">
                                                        {{valueItem.value}}
                                                    </van-checkbox>
                                                </div>
                                            </div>
                                        </van-checkbox-group>
                                    </div>
                                    
                                </div>
                            </div>
                            <!-- 隐私条款 -->
                            <div class="item itemCheck privacy-foo" v-if="privacyform.status == 1">
                                <van-checkbox-group v-model="privacyData">
                                    <van-checkbox name="隐私" :checked-color="checkedColor" shape="square" icon-size="16px" style="margin-right:3px"></van-checkbox>
                                </van-checkbox-group>
                                <span style="vertical-align: middle;">{{ privacyform.desc }}</span><span @click="gotoprivacy" style="color: #6cc4da;vertical-align: middle;">《{{ privacyform.title }}》</span>
                            </div>
                            <button class="commit-btn" @click="commitApplyForm">提交</button>
                        </div>
                    </transition>
                </div>
            </div>
        </van-popup>
        <van-popup v-model="industryShow" class="pop-indus" round position="bottom">
            <!-- <van-picker @confirm="onConfirm" @cancel="onCancel" show-toolbar title="请选择" :columns="labelList" value-key="name" /> -->
            <van-cascader v-model="fieldValue" active-color="#6cc4da" :options="labelList" :field-names="fieldNames"  @finish="onConfirm" @close="onCancel"></van-cascader>
        </van-popup>
        <!-- 城市 -->
        <van-popup v-model="cityShow" round position="bottom">
            <van-area @confirm="handleCitySure" @cancel="cityShow = false" title="城市选择" :area-list="areaList" :columns-num="2" />
        </van-popup>
    </div>
</template>

<script>
import { activityCreateForm,getPricacy,getOldActivity,getPhoneCode } from '@/api/activity'
import { groupCreateForm } from '@/api/polymerize'
import { getIndustryLabel, updateTag, getUserInfoData } from '@/api/label'
import { throttle } from '@/libs/util'
import { areaList } from '@vant/area-data'
import { getOS } from '@/libs/util';
import { getForm } from '@/api/polymerize';
import { getOldFormdata,createForm } from '@/api/form';
export default {
    props: {
        id: {
            type: Number,
            default: 0
        },
        type: {
            type: String,
            default: ''
        },
        type_id: {
            type: Number,
            default: ''
        },
    },
    data () {
        return {
            showACode:1,
            formDataList:[],
            formItem:{},
            form_title:'',
            fieldValue: '',
            fieldNames: {
                text: 'name',
                value: 'id',
            },
            industry_parent_id: '',
            industry_id: '',
            industryName: '', // 行业的名称
            industryShow:false,
            labelList: [], // 行业的列表
            areaList, // 城市
            cityName: '', // 城市名称
            cityShow: false,
            applyForm: false, // 表单是否显示
            // transitionEffect: 'van-fade', // 过渡效果
            showForm: true,
            closeOverlay: false, // 是否在点击遮罩层后关闭
            checkedColor: '#6cc4da', // 单选多选选中的颜色
            applyFormData: {},
            successHint: '提交成功', // 提交表单成功的文本提示
            // helpResult: [],
            product_type: '', // 索要价格的产品类型
            a: [],
            privacyData: [], 
            privacyform: {}, // 隐私条款
            getCodeText: '获取验证码',
            currentTime: 60,
            getCodeState: false, // 能否输入
            showCode: true,
            codeFirst: 1, // 用于验证 验证码
            oldPhone: '',//
            downorshare: '0', // 1 下载 2 分享
            groupId: '',
            browserUserId: '' // 浏览器id（安卓进入浏览器携带的）
        }
    },
    created () {
        let defailtFrom = localStorage.getItem('cusFrom')
        this.browserUserId = this.$route.query.uid
        if (JSON.parse(defailtFrom)) {
            // this.applyForm = true
            let formDataList = JSON.parse(localStorage.getItem('customNewFild'))
            this.applyFormData = JSON.parse(defailtFrom)
            this.$emit('proList',formDataList)
            console.log('再次进入自定义', this.applyFormData.inName);
            this.industryName = this.applyFormData.inName
            // this.showCode = this.applyFormData.prCode
            this.codeFirst = this.applyFormData.prcodeFirst
            console.log('再次进入自定义1', this.applyFormData.prCode);
        } else {
           
        }
        // console.log('进入的',this.formDataList);
        this.groupId = this.$route.query.id
        // this.formDataList.some(value => {
        //     if (value.field == 'products' || value.field == 'intention') {

        //     }
        // })
        this.getIndustryLabelPort()
        
    },
    mounted () {
        let defailtFrom = localStorage.getItem('cusFrom')
        window.onpageshow = function (e) {
            if (e.persisted || (window.performance && window.performance.navigation.type === 2)) {
                window.location.reload()
            }
        }
        this.getPricacyList()
        // if (!JSON.parse(defailtFrom)) {
            // 获取填写过的表单数据
            this.getshowCode()
        // }
        
    },
    
    methods: {
         // 获取类型数据
      getIndustryLabelPort () {
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
          duration: 0
        })
        getIndustryLabel().then(res => {
            if (res.errCode === 0) {
                var data = res.data
                this.labelList = data
                // console.log('数据', this.labelList);
                this.$toast.clear()
                } else {
                this.$toast.clear()
                this.$toast(res.errMsg)
                }
            })
        },
        getshowCode(){
            console.log('this.showACode',this.showACode);
            if(this.showACode){
                this.getOldFormdata()
            }else{
                setTimeout(()=>{
                    this.getshowCode()
                },1000)
            }
        },
        onCancel(picker, value, index) {
            // console.log('查看下',picker,value.id,index);
            this.industryShow = false
        },
        onConfirm (value,index) {
            console.log('查看下',value,index);
            
            this.industryShow = false
            let namearr = []
            value.selectedOptions.forEach(ele => {
                namearr.push(ele.name)
            })
            this.applyFormData.industry_parent_id = value.selectedOptions[0].id
            this.applyFormData.industry_id = value.selectedOptions[1].id
            this.industryName = namearr.join(',')
            // console.log('父级id',this.industry_parent_id,'子级id',this.industry_id);
            // this.handleData(this.labelList,index)
        },
        handleData(list, num) {
            let inde1 = num[0]
            let inde2 = num[1]
            let industry_id = ''
            let second = list.filter((element,ind) => {
                if (ind == inde1) {
                     this.industry_parent_id = element.id
                     return element
                }
            });
            second[0].children.forEach((val,inde) => {
                if (inde == inde2) {
                     
                     return this.industry_id = val.id
                }
            })
        },
        blurIndustry () {
            this.industryShow = true
        },
        blurCity() {
            this.cityShow = true
        },
        handleCitySure(data) {
            this.cityShow = false
            this.applyFormData['city'] = data[0].name+','+data[1].name
        },
        // 获取验证码
        getCode () {
            if(!/^1[23456789]\d{9}$/.test(this.applyFormData.mobile)) {
                this.$toast('请填写正确的手机号')
                return false
            }
            let para = {
                mobile: this.applyFormData.mobile
            }
            getPhoneCode(para).then(res => {
                console.log('获取的验证码',res);
                if (res.errCode != 0) {
                    this.$toast(res.errMsg)
                }
            })
            this.getCodeText= "60秒"
            this.getCodeState = true
            setTimeout(this.getcodeNumber,1000)
        },
        getcodeNumber(){
            let numTime = this.currentTime;
            numTime--;
            this.getCodeText= numTime+"秒"
            this.currentTime = numTime
    
            if (numTime <= 0){
                this.getCodeText= "获取验证码"
                this.getCodeState = false
                this.currentTime= '60'
            }else{
                setTimeout(this.getcodeNumber,1000)
            }
        },
        // 获取填写过的表单数据(进行默认字段填充)
        getOldFormdata () {
            let para = {
                user_id: this.$store.state.user.id || 46069,
                type:this.type,
                type_id:this.type_id
            }
            
            getOldFormdata(para).then(res => {
                console.log('查看下需要填充的数据',res,'父组件的显示验证码',this.showACode);
                let para = res.data
                // 判断是否显示验证码
                if (this.showACode == 1) { // 有高级字段（关注产品，购买意向）
                    // this.showCode = true
                    this.codeFirst = 1 
                } else { 
                    if (para.hasOwnProperty('mobile')) {
                        // this.showCode = false
                        this.codeFirst = 0
                    }
                }
                if (res.data) {
                    this.oldPhone = para.mobile
                    let fillForm = {
                        name: para.name || '',
                        email: para.email || '',
                        mobile: para.mobile || '',
                        company: para.company || '',
                        industry_id: para.industry_id || '',
                        industry_parent_id: para.industry_parent_id || '',
                        position: para.poisition || '',
                        poisition: para.poisition || ''
                    }
                    for (let key in fillForm) {
                        if (!fillForm[key]) {
                            delete fillForm[key]
                        }
                    }
                    if (res.data.industry_parent_title && res.data.industry_title) {
                        this.industryName = res.data.industry_parent_title + ',' + res.data.industry_title
                    }
                    this.applyFormData = fillForm
                    // this.$emit('proList',[fillForm])
                }
                // console.log('查看下1111111',this.applyFormData);
            })
        },
        // 获取隐私条款
        getPricacyList () {
            getPricacy().then(res => {
                this.privacyform = res.data
            })
        },
        // 跳转隐私
        gotoprivacy () {
           
            this.applyFormData.inName = this.industryName // 存回显的行业
            // this.applyFormData.prCode = this.showCode
            this.applyFormData.prcodeFirst = this.codeFirst
            let newCustom = JSON.stringify(this.applyFormData)
            localStorage.setItem('cusFrom',newCustom)
            this.$router.push({
                name: 'pricacy',
            })
        },
        // 打开填写表单
        showApplyForm () {
            this.getFormInfo()
            
            // console.log('直接打开1',this.applyFormData);
        },
        getFormInfo() {
            getForm({id: this.id}).then(res => {
                this.form_title = res.data.title
                this.formDataList = res.data.keys
                this.addPhoneCode()
            })
        },
        addPhoneCode() { // 添加验证码
        console.log('this.formDataList',this.formDataList)
            this.formDataList.forEach(item => {
                if (item.type === 2) {
                    this.formItem[item.field] = []
                } else {
                    this.formItem[item.field] = ''
                }
            })
            let moIndex = ''
            this.formDataList.filter((value,index) => {
                if (value.field == 'mobile') {
                    moIndex = index
                }
                if(value.field == 'code') {
                    moIndex = false
                }
            })
            if (moIndex) {
                let moblie = {
                    field: 'code',
                    required: 1,
                    title: '验证码',
                    type: 3,
                    value: "",
                    placeholder: "请输入验证码"
                }
                this.formDataList.splice(moIndex+1, 0, moblie)
            }
            this.applyFormData = { ...this.formItem, ... this.applyFormData }
            this.applyForm = true
        },
        // 初始化表单数据
        initForm () {
            this.applyFormData = {}
        },
        onChange (val) {
            console.log(this.applyFormData)
        },

        // 失去焦点
        blurChange () {
            setTimeout(() => {
                const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
                window.scrollTo(0, Math.max(scrollHeight - 1, 0))
            }, 100)
        },
        contrastPhone () {
            // console.log('获取手机号1',this.oldPhone);
            // console.log('获取手机号',this.applyFormData.mobile);
            if(this.showACode == 2) {
                if(this.oldPhone != this.applyFormData.mobile) {
                    // this.showCode = true
                    this.codeFirst = 1
                    // console.log('获取手机号1',this.oldPhone);
                } else {
                    console.log('获取手机号',this.applyFormData.mobile);
                    // this.showCode = false
                    this.codeFirst = 0
                }
            }
            
        },
        // 数据校验
        dataCheck () {
            // debugger
           
            const applyFormData = { ...this.applyFormData }
            console.log('applyFormData',this.formDataList);
            console.log('applyFormData',this.applyFormData.hasOwnProperty('industry_id'));
            console.log('applyFormData',this.applyFormData.hasOwnProperty('industry_parent_id'));
            const formDataList = this.formDataList
            for (var item of formDataList) {
                console.log('applyFormData',item.field);
                if (item.field == 'industry' && item.required && !this.applyFormData.hasOwnProperty('industry_id') && !this.applyFormData.hasOwnProperty('industry_parent_id')) {
                    this.$toast(`请将行业编辑完整`)
                    return false
                }
                // console.log(item)
                if (item.required && item.field != 'code' && item.field != 'industry') {
                    // console.log('里面的',applyFormData);
                    // console.log('里面的',applyFormData[item.field]);
                        if (applyFormData[item.field].constructor === Array && !applyFormData[item.field].length) {
                            if (item.placeholder) {
                                this.$toast(`${item.placeholder}`)
                            } else {
                                this.$toast(`请将${item.title}编辑完整`)
                               
                            }
                        
                            return false
                        } else if (!applyFormData[item.field]) {
                            if (item.placeholder) {
                                this.$toast(`${item.placeholder}`)
                            } else {
                                this.$toast(`请将${item.title}编辑完整`)
                            }
                        
                            return false
                        }
                    
                }
            }
            return true
        },
        // 单击提交表单
        commitApplyForm () {
            // console.log('this.applyFormData', this.applyFormData);
            // console.log('this.privacyData.length', this.privacyData.length < 1,this.privacyform.status);
            
            if(!/^1[23456789]\d{9}$/.test(this.applyFormData.mobile) && this.applyFormData.mobile) {
                this.$toast('请填写正确的手机号')
                
                return false
            }else if (this.applyFormData.email) { 
                // console.log(1);
                if (this.applyFormData.email.indexOf('@') === -1) {
                    this.$toast('请填写正确的邮箱')
                    return false
                } else if (this.privacyData.length < 1 && this.privacyform.status == 1) {
                    this.$toast('请勾选隐私条款')
                    return false
                }
            } else if (this.privacyData.length < 1 && this.privacyform.status == 1) {
                this.$toast('请勾选隐私条款')
                return false
            }else if (!this.applyFormData.code && this.showCode && this.applyFormData.mobile) {
                this.$toast('请输入验证码')
                return false
            }
            console.log('this.industryName',this.industryName)
            var params = {
                user_id: this.$store.state.user.id || 46069,
                // user_id: this.$store.state.user.id || this.browserUserId,
                type:this.type,
                type_id:this.type_id,
                industry_parent_id: this.industry_parent_id,
                industry_id: this.industry_id,
                industry:this.industryName,
            }
            var checkResult = this.dataCheck() // 校验必填数据
            if (!checkResult) {
                return false
            }
            const paramsData = Object.assign(params, { ...this.applyFormData})
            for (const j in paramsData) {
                if (Array.isArray(paramsData[j])) {
                    paramsData[j] = JSON.stringify(paramsData[j])
                }
            }
            console.log('父级id',this.industry_parent_id,'子级id',this.codeFirst);
            paramsData['is_first'] = this.codeFirst
            paramsData['industry'] = this.industryName
            console.log('打印参数', paramsData)
            // params.type = 3 // 聚合填写表单
            // ----------- 测试 ------------
            // if (this.downorshare == '1') { // 下载
            //     this.$emit('handleSon', '1')
            //     } else {
            //     this.$emit('handleSon', '2')
            //     }
            //     this.applyForm = false
            // ----------- 测试 ------------
            this.commotFormPort(paramsData) 
        },
        /** 网络请求 **/
        // 表单提交
        commotFormPort: throttle(
            function (params) {
                createForm(params).then((res) => {
                    if (res.errCode === 0) {
                        this.$emit('handleSon', '1')
                       this.applyForm = false
                       this.$toast('提交成功')
                    } else {
                        this.$toast(res.errMsg)
                    }
                }).catch((err) => {
                    console.log('表单提交失败', err)
                    this.$toast('表单提交失败,请稍后重试')
                })
            }, 3000)
    }
}
</script>

<style lang="scss" scoped>
.apply-form-container {
    .pop-indus {
        /deep/.van-picker{
            width: rem(303);
        }
    }
    .van-popup {
        border-radius: 6px;
    }
    .privacy-foo {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
    }
    .form-container {
        width: rem(303);
        /*height: rem(520);*/
        background: #fff;
        padding: rem(20) 0;
        .form-content {
            width: 85%;
            height: 100%;
            margin: 0 auto;
            .btn-switch {
                display: flex;
                justify-content: center;
                color: #2c2c2c;
                font-size: 15px;
                font-weight: bold;
                margin-bottom: rem(18);
                .btn {
                    background: #f5f5f5;
                    width: rem(115);
                    height: rem(30);
                    border: none;
                    outline: none;
                    border-radius: 4px;
                    &:nth-child(even) {
                        margin-left: 20px;
                    }
                }
                .select-btn {
                    background: $base-color;
                    color: #fff;
                    transition: all 0.2s;
                }
            }
            .form-list {
                height: rem(410);
                overflow-x: hidden;
                overflow-y: auto;
                .item {
                    margin: rem(6) 0;
                    .hint-title {
                        color: #2c2c2c;
                        font-size: rem(14);
                        display: inline-block;
                        margin-bottom: 5px;
                        .sign {
                            color: #d01818;
                            margin-right: 5px;
                        }
                    }
                    .content {
                        display: flex;
                        align-items: center;
                        width: 98%;
                        height: rem(30);
                        background: #f5f5f5;
                        border-radius: 4px;
                        margin-bottom: rem(5);
                        .left-icon {
                            width: 15%;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            position: relative;
                            .iconfont {
                                color: #4d4d4d;
                                font-size: rem(18);
                            }
                            .icon-xingming {
                                font-size: rem(15);
                            }
                            &:after {
                                content: '';
                                width: 1px;
                                height: rem(18);
                                background: #afafaf;
                                position: absolute;
                                top: 50%;
                                right: 0;
                                margin-top: rem(-9);
                            }
                        }
                        .right-input {
                            width: 85%;
                            padding-left: rem(10);
                            input {
                                width: 100%;
                                height: rem(30);
                                border: none;
                                background: none;
                            }
                            
                        }
                        .code_moblie {
                            display: flex;
                            align-items: center;
                        }
                    }
                    .radio-container {
                        // height: rem(30);
                        display: flex;
                        align-items: center;
                        font-size: rem(12);
                    }
                    .checkbox-container {
                        font-size: rem(12);
                        &:after {
                            content: '';
                            display: block;
                            clear: both;
                        }
                        .checkbox-option {
                            float: left;
                            width: 50%;
                            margin-bottom: 6px;
                        }
                        .checkbox-option:nth-child(9) {
                            width: 50%;
                        }
                        .checkbox-option:nth-child(10) {
                            width: 50%;
                        }
                    }
                    .group {
                        .van-checkbox {
                            margin: rem(6) 0;
                        }
                        .input-containers {
                            padding-left: rem(24);
                            .input-container {
                                border: 1px solid #cfcfcf;
                                box-sizing: border-box;
                                border-radius: 3px;
                                width: 95%;
                                .product-input {
                                    width: 90%;
                                    height: rem(23);
                                    text-indent: 5px;
                                    border: none;
                                    outline: none;
                                    background: #fff;
                                }
                            }
                        }
                    }
                }
            }
            .hint-text {
                color: #9d9d9d;
                font-size: 12px;
            }
            .commit-btn {
                width: rem(170);
                height: rem(40);
                background: $base-color;
                color: #fff;
                font-size: rem(16);
                border-radius: 4px;
                outline: none;
                border: none;
                display: block;
                margin: 0 auto;
                margin-top: rem(20);
                &:active {
                    background: #51c0dc;
                }
            }
        }
    }
    .success-container {
        width: rem(303);
        /*height: rem(250);*/
        height: auto;
        background: #fff;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        padding: rem(45) rem(30);
        box-sizing: border-box;
        .success-img {
            width: rem(84);
            height: rem(84);
        }
        .h3-tit {
            font-size: rem(16);
            color: #2c2c2c;
            margin: rem(10) 0;
        }
        .official-img {
            width: rem(100);
            height: rem(100);
            margin-top: rem(20);
        }
        .hint-text {
            color: #484848;
            font-size: 12px;
        }
        .close-icon {
            position: absolute;
            top: rem(15);
            right: rem(15);
            width: rem(20);
            height: rem(20);
            display: flex;
            align-items: center;
            justify-content: center;
            .iconfont {
                font-weight: bold;
                font-size: rem(25);
                color: #9d9d9d;
            }
        }
    }
}
</style>
